module.exports = __webpack_public_path__ + "static/media/glasses.adedc6de.svg";